// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"c8fd1804","228":"e90ab062","391":"ff2ccd7b","426":"9c191205","850":"fd2a1761"}[chunkId] + ".chunk.css";
};